var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LoadingIcon",class:{ 'LoadingIcon--inline': _vm.inline }},[_c('div',{staticClass:"LoadingIcon__icon"},[_vm._v("•")]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }